"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = DualView;
const react_1 = __importDefault(require("react"));
const links_to_translations_1 = __importDefault(require("./common/links-to-translations"));
const jit_load_1 = __importDefault(require("~/helpers/jit-load"));
const window_1 = __importDefault(require("~/contexts/window"));
const importPhoneView = () => Promise.resolve().then(() => __importStar(require('./phone-view/phone-view')));
const importDesktopView = () => Promise.resolve().then(() => __importStar(require('./desktop-view/desktop-view')));
function DualView() {
    const viewsUsed = useViewsUsed();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'phone-view' },
            react_1.default.createElement(links_to_translations_1.default, null),
            viewsUsed.phone && react_1.default.createElement(jit_load_1.default, { importFn: importPhoneView })),
        react_1.default.createElement("div", { className: 'bigger-view' },
            react_1.default.createElement(links_to_translations_1.default, null),
            viewsUsed.desktop && react_1.default.createElement(jit_load_1.default, { importFn: importDesktopView }))));
}
function useViewsUsed() {
    const { innerWidth } = (0, window_1.default)();
    const [phone, setPhone] = react_1.default.useState(false);
    const [desktop, setDesktop] = react_1.default.useState(false);
    react_1.default.useEffect(() => {
        if (innerWidth <= 600) {
            setPhone(true);
        }
        else {
            setDesktop(true);
        }
    }, [innerWidth]);
    return react_1.default.useMemo(() => ({
        phone,
        desktop
    }), [phone, desktop]);
}
